<template>
  <div
    class="rs-tags"
    :class="inputClasses"
  >
    <label
      v-if="label"
      :for="id"
    >{{ label }}<sup v-if="required">*</sup></label>
    <div
      v-if="imported"
      class="import-tooltip"
      :class="{ 'import-tooltip--open': importHover }"
    >
      <p>This field is managed by <strong>[Data Source]</strong>.<br>Changing this will be temporary.</p>
    </div>
    <BInputGroup>
      <BInputGroupPrepend
        v-if="imported"
        @click="toggleState"
        @mouseover="importHover = true"
        @mouseleave="importHover = false"
      >
        <span class="input-group-text">
          <RsIcon
            :icon="isUnlocked ? 'lock-open-alt' : 'lock-alt'"
          />
        </span>
      </BInputGroupPrepend>
      <BFormTags
        :value="value"
        :input-id="id"
        separator=","
        :required="required"
        :placeholder="placeholder"
        :disabled="disabled || (imported && isUnlocked == false)"
        no-add-on-enter
        remove-on-delete
        @input="$emit('input', $event)"
      />
    </BInputGroup>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsTags',

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    imported: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isUnlocked: false,
      importHover: false,
    };
  },
  computed: {
    inputClasses(): Record<string, boolean> {
      return {
        'rs-input--imported': this.imported,
        'rs-input--unlocked': this.isUnlocked,
      };
    },
  },
  methods: {
    toggleState(): void {
      this.isUnlocked = !this.isUnlocked;
    },
  },
});
</script>
<style lang="scss">
@import '@/styles/_variables.scss';
.rs-tags{
  position: relative;
  margin-bottom: 1rem;
  .b-form-tags{
    height: 40px;
  }
  ul{
    margin-top: 0 !important;
    .b-form-tag{
      background-color: lighten($info, 30%);
      font-weight: 600;
      cursor: default;
      &:hover{
        background-color: lighten($info, 25%);
      }
      span{
        color: darken($info, 30%);
        font-size: 0.875rem;
      }
      & > .close{
        font-size: 1.1rem;
        margin-left: 0.5rem;
        color: $info;
        opacity: 1;
        text-shadow: none;
      }
    }
  }
}

</style>
